<template>
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.0001 19.8C8.08816 19.8 6.8637 12.9115 6.64679 7.44776C6.58645 5.92797 6.55628 5.16807 7.12714 4.465C7.698 3.76192 8.38124 3.64665 9.74772 3.41609C11.0966 3.18851 12.8598 3 15.0001 3C17.1403 3 18.9036 3.18851 20.2525 3.41609C21.6189 3.64665 22.3022 3.76192 22.873 4.465C23.4439 5.16807 23.4137 5.92797 23.3534 7.44776C23.1365 12.9115 21.912 19.8 15.0001 19.8Z"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            d="M15 19.7988V23.3988"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linecap="round"
        />
        <path
            d="M19.2003 27H10.8003L11.2074 24.9647C11.3195 24.4038 11.812 24 12.3841 24H17.6165C18.1885 24 18.681 24.4038 18.7932 24.9647L19.2003 27Z"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M23.4001 6.59961L24.5384 6.97906C25.7265 7.37508 26.3205 7.57309 26.6603 8.04451C27.0001 8.51592 27.0001 9.14208 27 10.3944L27 10.4814C27 11.5143 27 12.0308 26.7514 12.4533C26.5027 12.8759 26.0513 13.1267 25.1484 13.6283L21.6001 15.5996"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            d="M6.59993 6.59961L5.46158 6.97906C4.27351 7.37508 3.67948 7.57309 3.33972 8.04451C2.99995 8.51592 2.99997 9.14208 3 10.3944L3 10.4814C3.00003 11.5143 3.00005 12.0308 3.24867 12.4533C3.4973 12.8759 3.94875 13.1267 4.85166 13.6283L8.39993 15.5996"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            d="M13.975 7.82662C14.431 7.00861 14.659 6.59961 14.9999 6.59961C15.3408 6.59961 15.5688 7.00861 16.0248 7.82662L16.1427 8.03825C16.2723 8.27071 16.3371 8.38693 16.4381 8.46362C16.5391 8.54031 16.665 8.56877 16.9166 8.62571L17.1457 8.67754C18.0312 8.87789 18.4739 8.97806 18.5792 9.31679C18.6846 9.65552 18.3827 10.0085 17.7791 10.7144L17.6229 10.897C17.4513 11.0976 17.3656 11.1979 17.327 11.322C17.2884 11.4461 17.3014 11.5799 17.3273 11.8475L17.3509 12.0912C17.4422 13.033 17.4878 13.5039 17.212 13.7133C16.9363 13.9226 16.5217 13.7318 15.6927 13.35L15.4782 13.2513C15.2426 13.1428 15.1248 13.0886 14.9999 13.0886C14.875 13.0886 14.7572 13.1428 14.5216 13.2513L14.3071 13.35C13.4781 13.7318 13.0635 13.9226 12.7878 13.7133C12.512 13.5039 12.5576 13.033 12.6489 12.0912L12.6725 11.8475C12.6984 11.5799 12.7114 11.4461 12.6728 11.322C12.6342 11.1979 12.5485 11.0976 12.3769 10.897L12.2207 10.7144C11.6171 10.0085 11.3152 9.65552 11.4206 9.31679C11.5259 8.97806 11.9687 8.87789 12.8541 8.67754L13.0832 8.62571C13.3348 8.56877 13.4607 8.54031 13.5617 8.46362C13.6627 8.38693 13.7275 8.27071 13.8571 8.03825L13.975 7.82662Z"
            stroke="currentColor"
            stroke-width="1.4"
        />
        <path
            d="M22.2003 27H7.80029"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
        />
    </svg>
</template>

<script>
export default {
    name: "CupStarIcon",
};
</script>
